import React from 'react'
import { useLocale } from '@transifex/react'
import isoCountries from 'i18n-iso-countries'
import arLocale from 'i18n-iso-countries/langs/ar.json'
import daLocale from 'i18n-iso-countries/langs/da.json'
import enLocale from 'i18n-iso-countries/langs/en.json'
import fiLocale from 'i18n-iso-countries/langs/fi.json'
import nbLocale from 'i18n-iso-countries/langs/nb.json'
import svLocale from 'i18n-iso-countries/langs/sv.json'
import { Select, SelectProps } from 'src/antd'

isoCountries.registerLocale(arLocale)
isoCountries.registerLocale(daLocale)
isoCountries.registerLocale(enLocale)
isoCountries.registerLocale(fiLocale)
isoCountries.registerLocale(nbLocale)
isoCountries.registerLocale(svLocale)

const useCountrySelectOptions = () => {
  const locale = useLocale()

  // Handle locale codes like 'en-gb' -> 'en' and fallback to 'en' if undefined
  const normalizedLocale = locale?.split('-')[0] || 'en'

  const options = Object.entries(isoCountries.getNames(normalizedLocale)).map(
    ([key, value]) => ({
      label: value,
      value: key,
    })
  )

  return options
}

export type TSelectCountry = React.FC<
  SelectProps<string> & { disableNative?: boolean }
>

const SelectCountry: TSelectCountry = ({ ...props }) => {
  const options = useCountrySelectOptions()

  return (
    <Select options={options} showSearch optionFilterProp="label" {...props} />
  )
}

export { SelectCountry, useCountrySelectOptions }
